import { motion } from "motion/react";

export const AnimatedText = ({ children, className = "" }: { children: string; className?: string }) => {
  const words = children.split(" ");
  
  return (
    <div className={className}>
      {words.map((word, wordIndex) => (
        <span key={wordIndex} className="inline-block">
          <motion.span
            initial={{ y: 4, opacity: 0, filter: "blur(1px)" }}
            animate={{ y: 0, opacity: 1, filter: "blur(0px)" }}
            transition={{
              delay: wordIndex * 0.05,
              duration: 0.7,
              ease: [0.25, 0.4, 0.2, 1],
            }}
          >
            {word}
            {wordIndex < words.length - 1 && "\u00A0"}
          </motion.span>
        </span>
      ))}
    </div>
  );
}